export default {
  title: 'Gateways de Pagamento',
  fields: {
    name: 'Nome',
    payment_gateway: 'Gateways de Pagamento',
    live_from: 'Ativo Desde',
    last_30_days_sales: 'Vendas dos Últimos 30 Dias',
    kyc_deadlines: 'Prazos KYC',
    actions: 'Ações',
  },
  stats: {
    active_on_stripe: 'Ativo no Stripe',
    active_on_adyen: 'Ativo no Adyen',
    adyen_verification_pending: 'Verificação Adyen Pendente',
  },
  filters: {
    search_placeholder: 'Pesquisar por nome...',
    gateway_status_placeholder: 'Todos os gateways',
  },
  not_configured: {
    title: 'Os pagamentos ainda não estão configurados',
    description:
      'Nenhum fornecedor de pagamento está ligado à sua conta. Os restaurantes podem ser totalmente configurados, mas não podem ficar ativos nem aceitar pagamentos online enquanto os pagamentos não estiverem configurados.',
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (Pendente)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Verificado',
    pending: 'Pendente',
    rejected: 'Rejeitado',
  },
  buttons: {
    actions: 'Ações',
    switch_to: 'Mudar para {{gateway}}',
    view_details: 'Ver detalhes',
    open_onboarding: 'Abrir onboarding',
    create_onboarding_link: 'Criar link de onboarding',
  },
  modal: {
    title: 'Mudar Gateway de Pagamento',
    description:
      'Tem a certeza de que pretende mudar {{companyName}} de <bold>{{currentGateway}}</bold> para <bold>{{targetGateway}}</bold>?',
    not_verified_warning:
      '{{gateway}} não está verificado para esta empresa. O processamento de pagamentos pode ser afetado.',
    confirm: 'Mudar',
    cancel: 'Cancelar',
  },
  details_modal: {
    title: '{{companyName}} — Detalhes do Gateway de Pagamento',
    requirements: 'Requisitos',
    no_requirements: 'Sem requisitos pendentes.',
    deadline: 'Prazo',
    capabilities: 'Capacidades',
    onboarding_links: {
      section_title: 'Link de Onboarding',
      active_link: 'Link ativo',
      expires: 'Expira {{date}}',
      create_button: 'Criar link',
      extend_button: 'Prolongar link',
      loading: 'A carregar links…',
    },
  },
  toasts: {
    onboarding_link_failed: 'Falha ao criar link de onboarding.',
    switch_success: 'Gateway de pagamento alterado com sucesso.',
    switch_failed: 'Falha ao mudar o gateway de pagamento.',
    failed_to_load_data: 'Falha ao carregar os dados.',
  },
};
